import type { Occupation } from "@/common/types/occupation";
import axiosClient from "@/lib/axios/axiosClient";

export const getOccupations = async (): Promise<Occupation[]> => {
  const response = await axiosClient.get<Occupation[]>("/occupations", {
    sendToken: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "text/plain; charset=utf-8",
    },
  });

  return response.data;
};
